import { SetState } from 'zustand';
// import { i18n } from '~/i18n/i18n'
// import { storeState } from '~/store'
import { buildPdfBlobFromApiResponse, triggerPdfDownload } from '~/utils/downloadPdf';
import { ContractByHashIdResponse, ContractStore, Insured, InsuredItem, Plan, UserForm } from './types';
// import axios, { AxiosError } from 'axios'
import ContractService from '~/services/modules/contract';

const contractService = ContractService as {
  getContractByHashId(hashId: string, organizationId?: string): Promise<ContractByHashIdResponse>;
};
import {
  ContractPostAddress,
  ContractPostCustomer,
  ContractPostEmergency,
  ContractPostEquipment,
  ContractPostFiles
} from '~/services/modules/contract/types';

const createQuoteSlice = (set: SetState<ContractStore>) => ({
  userForm: {},
  step: 'none',
  contract_id: null,
  cameFromEmail: false,
  manufacturers: [],
  voucher: '',
  contractResponse: { contract_id: '', contract_code: '', is_renew_outdated: false },
  insured: {} as Insured,
  insured_item: {} as InsuredItem,
  plan: {} as Plan,
  flat_rate: 0,
  has_club: false,
  club_name: '',
  club_description: '',
  setUserForm: (user: UserForm) => {
    set({ user: user });
  },
  setContractId: (contract_id: number) => {
    set({ contract_id: contract_id });
  },
  setCameFromEmail: (cameFromEmail: boolean) => {
    set({ cameFromEmail });
  },
  contractAsyncGetContext: async (contract_id: number, organizationId?: string, callback?: () => void) => {
    const contractContext = await ContractService.getContext(contract_id, organizationId);
    const { step } = contractContext;
    set({ step, contract_id });
    callback && callback();
  },
  contractAsyncGetContractById: async (contract_id: number, callback?: () => void) => {
    const response = await ContractService.getContractById(contract_id);

    const {
      insured,
      insured_item,
      total: totalValue,
      financial_charges: serviceCharge,
      plan,
      flat_rate,
      plan: { has_club, club_name, club_description }
    } = response;

    set({
      insured,
      insured_item,
      totalValue,
      serviceCharge,
      plan,
      flat_rate,
      has_club,
      club_name,
      club_description
    });
    callback && callback();
  },
  contractAsyncGetContractByHashId: async (hashId: string, organizationId?: string, callback?: () => void) => {
    const response = await contractService.getContractByHashId(hashId, organizationId);

    console.log('Resposta da API v2:', response);

    const {
      insured,
      insured_item,
      total: totalValue,
      financial_charges: serviceCharge,
      plan,
      flat_rate,
      contract_id
    } = response;

    const { has_club, club_name, club_description } = plan || {};

    set({
      insured,
      insured_item,
      totalValue,
      serviceCharge,
      plan,
      flat_rate,
      has_club: has_club ?? false,
      club_name: club_name ?? '',
      club_description: club_description ?? '',
      contract_id
    });
    callback && callback();
  },
  contractAsyncPostCustomer: async (
    contract_id: string,
    body: ContractPostCustomer,
    organizationId?: string,
    callback?: () => void
  ) => {
    await ContractService.postCustomer(contract_id, body, organizationId);
    callback && callback();
  },
  contractAsyncPostAddress: async (
    contract_id: string,
    body: ContractPostAddress,
    organizationId?: string,
    callback?: () => void
  ) => {
    await ContractService.postInsuredItemAddress(contract_id, body, organizationId);
    callback && callback();
  },
  contractAsyncGetManufacturer: async (callback?: () => void) => {
    try {
      const data = await ContractService.getManufacturers();
      set({ manufacturers: data });
      callback && callback();
    } catch (error) {
      // set({ quote: null })
    }
  },
  contractAsyncPutEquipment: async (
    contract_id: number,
    body: ContractPostEquipment,
    organizationId?: string,
    callback?: () => void
  ) => {
    await ContractService.putInsuredItem(contract_id, body, organizationId);
    callback && callback();
  },
  contractAsyncPostEmergency: async (
    contract_id: number,
    body: ContractPostEmergency,
    organizationId?: string,
    callback?: () => void
  ) => {
    await ContractService.postEmergency(contract_id, body, organizationId);
    callback && callback();
  },
  contractAsyncDownload: async (contract_id: string, organizationId?: string, callback?: () => void) => {
    const response = await ContractService.getDownload(contract_id, organizationId);
    const blob = buildPdfBlobFromApiResponse(response.data);
    triggerPdfDownload(blob, 'contrato-aride.pdf');
    callback && callback();
  },
  contractAsyncPostFiles: async (
    contract_id: string,
    body: ContractPostFiles,
    organizationId?: string,
    callback?: () => void
  ) => {
    const data = await ContractService.postFiles(contract_id, body, organizationId);
    callback && callback();
    return data;
  },
  contractAsyncGetVoucher: async (contract_id: number, organizationId?: string, callback?: () => void) => {
    const { data } = await ContractService.getVoucher(contract_id, organizationId);
    set({ voucher: data.voucher });
    callback && callback();
  },
  contractAsyncPostPromotion: async (
    quote_id: string,
    payload?: any,
    organizationId?: string,
    callback?: () => void
  ) => {
    const response = await ContractService.postContractPromotion(quote_id, payload, organizationId);
    set({ contractResponse: response.data });
    callback && callback();
  }
});

export default createQuoteSlice;
